import { createAction } from '@reduxjs/toolkit';
import { types } from './types';

export const disconnect = () => ({
    type: types.DISCONNECT,
});

export const userTyping = (payload: any) => ({
    type: types.USER_TYPING,
    payload,
});

export const userStopTyping = (payload: any) => ({
    type: types.USER_STOP_TYPING,
    payload,
});

type OnlineStatus = 'online' | 'offline';

export type NewContentType = 'audition' | 'act' | 'talents';

export const setOnlineStatus = createAction<OnlineStatus>(types.SET_ONLINE_STATUS);
export const setOnlineUsers = createAction<OnlineStatus>(types.SET_ONLINE_USERS);
export const setOfflineUsers = createAction<any>(types.SET_OFFLINE_USER);

export const connect = createAction(types.CONNECT);
export const connectSuccess = createAction<any>(types.CONNECT_SUCCESS);
export const connectFail = createAction<any>(types.CONNECT_FAIL);

export const disconnectSuccess = createAction<any>(types.DISCONNECT_SUCCESS);
